module.exports = __webpack_public_path__ + "static/media/vortex.74bd3e4d.png";